<template>
  <div v-if="load">
    <scale-loader />
  </div>
  <tabs v-else-if="group_info" parent="simcard_profile_group">
    <tab id="info" :name="translate('rpc_template.info')" :href="url+'/info'">
      <Info
          :group="group_info"
          :members="members"
          :total="total"
          :limit="limit"
          :offset="offset"
          @change-page="change_page"
      />
    </tab>
  </tabs>
  <div v-else class="wrapper-full-page section content">
    <div class="container">
      <div class="row">
        <div class="col-md-8 col-md-offset-2 text-center">
          <h2 class="title text-danger">{{ translate('no_data') }}</h2>
          <router-link to="/simcard_profile_list/groups">{{ translate('simcard_profile_group.many') }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import Info from './Tabs/Info/Index.vue'

export default {
  name: 'SimCardProfileGroup',
  components: {
    Info,
    Tab,
    Tabs
  },
  data() {
    return {
      group_info: null,
      members: [],
      total: 0,
      limit: 100,
      offset: 0,
      load: true
    }
  },
  computed: {
    url() { return '/simcard_profile_group/' + this.cur_id },
    cur_id() { return this.$route.params.simcard_profile_group_id }
  },
  watch: {
    cur_id() {
      if (this.cur_id && this.$route.name === 'simcard_profile_group_section') {
        this.group_info = null
        this.offset = 0
        this.get_group()
      }
    },
    group_info() {
      if (this.$route.name === 'simcard_profile_group_section' && this.group_info) {
        this.$store.commit('updateOtherTitle', this.group_info.name)
      }
    }
  },
  activated() {
    this.get_group()
  },
  deactivated() {
    this.$store.commit('updateOtherTitle', '')
  },
  methods: {
    change_page(offset) {
      this.offset = offset
      this.get_group()
    },
    get_group() {
      let id = this.cur_id
      if (!id) return
      this.load = true
      this.$http.simcard.getSimcardProfileGroupInfo(id, {include_history: 1, limit: this.limit, offset: this.offset}, (response) => {
        if (id !== this.cur_id) return
        this.group_info = response.data.group
        this.members = response.data.members
        this.total = response.data.total
        this.load = false
      })
    }
  }
}
</script>
